import { render, staticRenderFns } from "./com-edit-adinfo.vue?vue&type=template&id=312bdd2c&"
import script from "./com-edit-adinfo.vue?vue&type=script&lang=js&"
export * from "./com-edit-adinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports